module.exports = __webpack_public_path__ + "static/img/banner-home.a307c75e.jpg";